import { createFileRoute, redirect } from '@tanstack/react-router';

import { resolveStartupHref } from '@/features/last-location/startup-location.js';

/**
 * The root has no page of its own. A real load is sent to the page the user had open last (see
 * {@link resolveStartupHref}); a link preload goes straight to Home so it cannot use up that restore.
 */
export const Route = createFileRoute('/')({
  beforeLoad: async ({ preload }) => {
    throw redirect({
      href: preload ? '/home' : await resolveStartupHref(),
      replace: true,
    });
  },
});
